export default {
    navigationBarTitleText: intl.get('mobileLandingPage.title.free'),
    navigationBarBackgroundColor: "#DF773C",
};
